import { LinkButton } from '@framework/ui/components/button/LinkButton.tsx';
import { useCurrentMenuKey } from '@framework/ui/core/router/breadcrumbs/BreadcrumbContext.tsx';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import styled from 'styled-components';

const StyledLoginButton = styled(LinkButton)`
  &&& {
    &:focus-visible {
      outline: 2px solid ${props => props.theme.focusOutlineNegativeColor} !important;
      outline-offset: 0px !important;
      transition: all 0.2s;
    }
  }
`;

export interface LoginButtonProps {}
/**
 * Pulsante per andare alla pagina di login.
 */
export function LoginButton(props: LoginButtonProps) {
  const menuKey = useCurrentMenuKey();
  const location = useLocation();
  const { t } = useTranslation();

  if (menuKey[0] === 'login') return null;

  return (
    <StyledLoginButton
      type="primary"
      to={{ pathname: '/login', state: { from: location } }}
      size="large"
    >
      {t('login-button.accedi', 'Accedi')}
    </StyledLoginButton>
  );
}
